import React, { memo, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { notificationStore } from '../../store/notificationStore';
import useTranslation from '../../hooks/useTranslation';
import { NotificationByCode } from '../../core/constants/notification';
import {
  ErrorMessagesForGamesByRound,
  ResponseTypeForGamesByRound,
  ValidationResponseCodeForGameByRound,
  ValidationType,
  ValidationTypeForGamesByRound,
} from '../../core/constants/validationType';
import { isResponseNotEnoughBalance } from '../../core/helpers/isResponseNotEnoughBalance';
import { applicationStore } from '../../store/applicationStore';
import { popupStore } from '../../store/popupStore';
import { PopupTypes } from '../../core/constants/popupTypes';
import { isPG } from '../../core/helpers/skinHelper';
import './notification.scss';

const Notification = observer(({ isRoundGame }) => {
  const { notification, operatorError } = notificationStore;
  const { hasDepositPopup } = applicationStore;

  const t = useTranslation();

  const notificationTypes = useMemo(() => {
    if (operatorError) {
      return {
        className: 'error',
        icon: 'close',
      };
    }
    if (
      +notification ===
      ValidationResponseCodeForGameByRound[ResponseTypeForGamesByRound.GameReturnedNotify]
    ) {
      return {
        className: 'unfinished',
        icon: 'info',
      };
    }
    if (+notification === ValidationType.Success && isPG() && !isRoundGame) {
      return {
        className: 'accepted',
        icon: 'accepted',
      };
    }
    if (
      (+notification === ValidationType.NotEnoughMoney ||
        +notification === ValidationType.MaintenanceNotify) &&
      isPG() &&
      !isRoundGame
    ) {
      return {
        className: 'not-balance',
        icon: 'warning',
      };
    }
    if (
      +notification === ValidationResponseCodeForGameByRound[ResponseTypeForGamesByRound.Success] &&
      isPG() &&
      isRoundGame
    ) {
      return {
        className: 'accepted',
        icon: 'accepted',
      };
    }
    if (
      (+notification ===
        ValidationResponseCodeForGameByRound[ResponseTypeForGamesByRound.NotEnoughBalance] ||
        +notification ===
          ValidationResponseCodeForGameByRound[ResponseTypeForGamesByRound.MaintenanceNotify]) &&
      isPG() &&
      isRoundGame
    ) {
      return {
        className: 'not-balance',
        icon: 'warning',
      };
    }
    return {
      className: 'error',
      icon: 'close',
    };
  }, [operatorError, notification, isRoundGame]);

  if (notification === '' && !operatorError) {
    return null;
  }

  if (!operatorError && isResponseNotEnoughBalance(notification) && hasDepositPopup) {
    popupStore.open({ name: PopupTypes.Deposit });
    return null;
  }

  if (!operatorError && notification === ValidationType.Success && !isPG()) {
    return null;
  }

  return (
    <>
      {/* Todo add class accepted, error, not-balance, unfinished */}
      <div className={`game-notification ${notificationTypes.className}`}>
        {/* Todo change icon classname  icon-accepted, icon-warning, icon-close */}
        <i className={`icon-${notificationTypes.icon}`} />
        <span className='game-notification-txt'>
          {operatorError ||
            (isRoundGame
              ? t(ErrorMessagesForGamesByRound[ValidationTypeForGamesByRound[notification]])
              : t(NotificationByCode[notification]))}
        </span>
      </div>
    </>
  );
});
export default memo(Notification);
